module.exports = __webpack_public_path__ + "img/1.a284c2cd.svg";